// Base Units of Measure — decimal rules mirror backend/uom.py.
export const SUGGESTED_UOMS = [
  { name: "Litre", decimals: 3 },
  { name: "Millilitre", decimals: 0 },
  { name: "Kilogram", decimals: 3 },
  { name: "Gram", decimals: 0 },
  { name: "Bottle", decimals: 0 },
  { name: "Piece", decimals: 0 },
  { name: "Sachet", decimals: 0 },
  { name: "Kit", decimals: 0 },
  { name: "Roll", decimals: 0 },
  { name: "Box", decimals: 0 },
  { name: "Pack", decimals: 0 },
  { name: "Set", decimals: 0 },
  { name: "Pair", decimals: 0 },
  { name: "Can", decimals: 0 },
  { name: "Tube", decimals: 0 },
  { name: "Bag", decimals: 0 },
];

const SUGGESTED_MAP = SUGGESTED_UOMS.reduce((m, u) => { m[u.name.toLowerCase()] = u.decimals; return m; }, {});

export function uomDecimals(name, customUoms = []) {
  if (!name) return 0;
  const key = String(name).trim().toLowerCase();
  if (key in SUGGESTED_MAP) return SUGGESTED_MAP[key];
  const c = (customUoms || []).find((u) => (u.name || "").trim().toLowerCase() === key);
  if (c) return Number(c.decimals) >= 3 ? 3 : 0;
  return 0;
}

// Step attribute for a numeric input based on the item's base UOM.
export function uomStep(baseUom, customUoms = []) {
  const d = uomDecimals(baseUom, customUoms);
  return d === 0 ? "1" : `0.${"0".repeat(d - 1)}1`;
}

// Returns error string if invalid, else null.
export function validateUomQty(baseUom, qty, customUoms = []) {
  const d = uomDecimals(baseUom, customUoms);
  const q = Number(qty);
  if (Number.isNaN(q) || q <= 0) return "Quantity must be greater than zero";
  const factor = Math.pow(10, d);
  if (Math.abs(q * factor - Math.round(q * factor)) > 1e-6) {
    return d === 0
      ? "Whole numbers only for this unit of measure"
      : `At most ${d} decimal place(s) for this unit of measure`;
  }
  return null;
}
